import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Box,
    Avatar,
    Menu,
    MenuItem,
    Tooltip,
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    Divider,
    CssBaseline,
} from '@mui/material';

import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StoreIcon from '@mui/icons-material/Store';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import Inventory2Icon from "@mui/icons-material/Inventory2";


// Mock user data for the example
const mockUserData = {
    name: 'Shivamba ',
    email: '',
};

// -----------------------------------------------------------------------------
// Shopheader Component
// -----------------------------------------------------------------------------
const Shopheader = ({ onMenuClick }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleLogout = () => {
        // In a real application, you would handle the sign-out logic here
        console.log('User signed out.');
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const userInitial = mockUserData?.name?.charAt(0)?.toUpperCase() || 'U';

    return (
        <AppBar
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                background: 'linear-gradient(90deg, #b53f3fff 0%, #bbb009ff 50%, #9c27b0 100%)',
            }}
        >
            <Toolbar>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={onMenuClick}
                    sx={{ mr: 2 }}
                >
                    <MenuIcon />
                </IconButton>

                <Typography variant="b" noWrap sx={{ flexGrow: 1 }}>
                    शिवअंबा पूजा साहित्य व प्रासादिक भांडार
                </Typography>

                <Box>
                    <Tooltip title="Profile">
                        <IconButton onClick={handleMenuOpen} size="small" sx={{ ml: 2 }}>
                            <Avatar sx={{ width: 32, height: 32 }}>
                                {userInitial}
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        onClick={handleMenuClose}
                        PaperProps={{
                            elevation: 3,
                            sx: { mt: 1.5 },
                        }}
                    >
                        <MenuItem disabled>
                            <Typography variant="subtitle1">
                                {mockUserData?.name || mockUserData?.email || 'Guest'}
                            </Typography>
                        </MenuItem>
                        <MenuItem onClick={handleLogout}>
                            <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                            Logout
                        </MenuItem>
                        <MenuItem component={Link} to="/home" >
                            Back To Home
                        </MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    );
};


const drawerWidth = 240;

// ------------------------ Updated Sidebar ------------------------
const Sidebar = ({ isOpen, onClose }) => {
    const [openCustomer, setOpenCustomer] = useState(false);
    const [openVendors, setOpenVendors] = useState(false);
    const [openReports, setOpenReports] = useState(false);
    const [openProducts, setOpenProducts] = useState(false);
    const [openSale, setOpenSale] = useState(false);       // NEW
    const [openPurchase, setOpenPurchase] = useState(false); // NEW

    return (
        <Drawer
            variant="temporary"
            open={isOpen}
            onClose={onClose}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    background: 'linear-gradient(to bottom, #9a0b0bff, #b45808ff)',
                    color: '#fff',
                    borderRight: 'none',
                },
            }}
            elevation={3}
        >
            <Toolbar />
            <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)' }} />

            <List component="nav">
                {/* Dashboard */}
                <ListItemButton component={Link} to="/category/shop" sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}><HomeIcon /></ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItemButton>

                {/* Products */}
                <ListItemButton onClick={() => setOpenProducts(!openProducts)} sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}><Inventory2Icon /></ListItemIcon>
                    <ListItemText primary="प्रोडक्ट " />
                    {openProducts ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openProducts} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton component={Link} to="/products/shop" sx={styles.subMenuItem}>
                            <ListItemText primary="प्रोडक्ट नवीन ऍड करणे  " />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/product-sizes/shop" sx={styles.subMenuItem}>
                            <ListItemText primary="प्रोडक्ट साईज " />
                        </ListItemButton>
                    </List>
                </Collapse>

                {/* Customer */}
                <ListItemButton onClick={() => setOpenCustomer(!openCustomer)} sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}><PersonIcon /></ListItemIcon>
                    <ListItemText primary="ग्राहक" />
                    {openCustomer ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openCustomer} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton component={Link} to="/customers-mgmt/shop" sx={styles.subMenuItem}>
                            <ListItemText primary="नवीन ग्राहक ऍड करणे " />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/customers-account/shop" sx={styles.subMenuItem}>
                            <ListItemText primary="ग्राहक अकाउंटिंग " />
                        </ListItemButton>
                    </List>
                </Collapse>

                {/* Sale */}
                <ListItemButton onClick={() => setOpenSale(!openSale)} sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}><ShoppingCartIcon /></ListItemIcon>
                    <ListItemText primary="विक्री" />
                    {openSale ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openSale} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton component={Link} to="/sales/shop" sx={styles.subMenuItem}>
                            <ListItemText primary="नवीन विक्री" />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/view-sale/shop" sx={styles.subMenuItem}>
                            <ListItemText primary="विक्री पाहा" />
                        </ListItemButton>
                    </List>
                </Collapse>

                {/* Vendors */}
                <ListItemButton onClick={() => setOpenVendors(!openVendors)} sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}><StoreIcon /></ListItemIcon>
                    <ListItemText primary="विक्रेते" />
                    {openVendors ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openVendors} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton component={Link} to="/vendors-mgmt/shop" sx={styles.subMenuItem}>
                            <ListItemText primary="नवीन विक्रेता ऍड करणे " />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/vendors-account/shop" sx={styles.subMenuItem}>
                            <ListItemText primary="विक्रेता अकाउंटिंग" />
                        </ListItemButton>
                    </List>
                </Collapse>

                {/* Purchase */}
                <ListItemButton onClick={() => setOpenPurchase(!openPurchase)} sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}><ShoppingBagIcon /></ListItemIcon>
                    <ListItemText primary="खरेदी" />
                    {openPurchase ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openPurchase} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton component={Link} to="/purchase/shop" sx={styles.subMenuItem}>
                            <ListItemText primary="नवीन खरेदी" />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/view-purchase/shop" sx={styles.subMenuItem}>
                            <ListItemText primary="खरेदी पाहा" />
                        </ListItemButton>
                    </List>
                </Collapse>

                {/* Reports */}
                <ListItemButton onClick={() => setOpenReports(!openReports)} sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}><ShowChartIcon /></ListItemIcon>
                    <ListItemText primary="रिपोर्ट  " />
                    {openReports ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openReports} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton component={Link} to="/reports-sales/shop" sx={{ pl: 4 }}>
                            <ListItemText primary="विक्री  रिपोर्ट " />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/reports-purchase/shop" sx={{ pl: 4 }}>
                            <ListItemText primary="खरेदी  रिपोर्ट " />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/reports-customers/shop" sx={{ pl: 4 }}>
                            <ListItemText primary="ग्राहक  रिपोर्ट " />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/reports-vendors/shop" sx={{ pl: 4 }}>
                            <ListItemText primary="विक्रेता  रिपोर्ट " />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/reports-customer-outstanding/shop" sx={{ pl: 4 }}>
                            <ListItemText primary="ग्राहक उधारी " />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/reports-vendor-outstanding/shop" sx={{ pl: 4 }}>
                            <ListItemText primary="विक्रेता उधारी" />
                        </ListItemButton>
                        {/* <ListItemButton component={Link} to="/reports-income/shop" sx={{ pl: 4 }}>
                            <ListItemText primary="Income Report" />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/reports-expense/shop" sx={{ pl: 4 }}>
                            <ListItemText primary="Expense Report" />
                        </ListItemButton> */}
                    </List>
                </Collapse>
            </List>
        </Drawer>
    );
};



const styles = {
    menuItem: {
        px: 2,
        py: 1.5,
        color: '#fff',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
    menuIcon: {
        color: '#fff',
        minWidth: '40px',
    },
    subMenuItem: {
        pl: 5,
        py: 1,
        color: '#ddd',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
};

// -----------------------------------------------------------------------------
// Main App Component
// -----------------------------------------------------------------------------
const Index = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const theme = createTheme();

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <Shopheader onMenuClick={toggleSidebar} />
                <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
            </Box>
        </ThemeProvider>
    );
};

export default Index;
